import { useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import {
  createAutoSquareImage,
  imageInputAccept,
  isSupportedImageFile,
  supportedImageTypesLabel,
} from '../../../settings/imageUploadUtils'
import { Manifest } from '../StudioManifest'
import { StudioUtils } from '../StudioUtils'

export function SelectImageDialog(props: any) {
  const [imageSource, setImageSource] = useState('predefined')

  const uploadPicture = async (e: any) => {
    if (!e.target.files[0]) {
      toast.error('Opplastning feilet')
      return
    }
    const fileSize = e.target.files[0].size
    const maxFileSize = 2 * 1024 * 1024 // 2MB in bytes
    const selectedFile = e.target.files[0]

    if (!isSupportedImageFile(selectedFile)) {
      toast.error(`Tillatt filtype: ${supportedImageTypesLabel}.`)
      return
    }

    if (fileSize > maxFileSize) {
      toast.error('Filstørrelsen må være mindre enn 2MB.')
      return
    }

    try {
      const processedFile = await createAutoSquareImage(selectedFile)
      const reader = new FileReader()

      reader.readAsDataURL(processedFile)
      reader.onload = () => {
        const base64 = reader.result as string
        props.setImage({
          base64,
        })
        props.onHide()
      }
    } catch (error) {
      console.error(error)
      toast.error('Kunne ikke behandle bildet.')
      return
    }
  }

  return (
    <Modal {...props} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>Velg bilde</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div key='image-radio' className='mb-3'>
          <Form.Check
            inline
            label='Predefinerte bilder'
            name='group1'
            type='radio'
            checked={imageSource === 'predefined'}
            id='image-radio-1'
            onChange={() => {
              setImageSource('predefined')
            }}
          />
          <Form.Check
            inline
            label='Last opp bilde'
            name='group1'
            type='radio'
            id='image-radio-2'
            checked={imageSource === 'upload'}
            onChange={() => {
              setImageSource('upload')
            }}
          />
        </div>
        {imageSource === 'predefined' && (
          <div className='select-image'>
            {Manifest.uneditedImagesArr.map((image, index) => (
              <button
                key={index}
                className='image-container'
                onClick={async () => {
                  const base64 = await StudioUtils.imageUrlToBase64(image.src, () => {})
                  props.setImage({
                    base64,
                  })
                  props.onHide()
                }}
              >
                <Spinner animation='border' />
                <img key={index} src={image.src} alt={image.title} />
              </button>
            ))}
          </div>
        )}
        {imageSource === 'upload' && (
          <Form.Group controlId='formFile'>
            <Form.Label>Last opp bilde</Form.Label>
            <Form.Control
              type='file'
              accept={imageInputAccept}
              className='mb-3 editor-upload-image'
              onChange={(e) => {
                uploadPicture(e)
              }}
            />
            <div className='text-muted small'>{`Tillatt filtype: ${supportedImageTypesLabel}.`}</div>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Lukk</Button>
      </Modal.Footer>
    </Modal>
  )
}
